import * as Yup from 'yup';


export const ccMaxEleapsedYear = 19;


export const braintreeTypeMap = {
    visa: 'visa',
    mastercard: 'mastercard',
    'american-express': 'americanexpress',
    'diners-club': 'dinersclub',
    discover: 'discovercard',
    maestro: 'maestro'
};

export const validCardShape = Yup.object().shape({
    niceType: Yup.string(),
    type: Yup.string(),
    gaps: Yup.array(),
    lengths: Yup.array(),
    code: Yup.object()
});

export const validNumberShape = Yup.object().shape({
    card: validCardShape.default(() => ({ type: 'hello' })),
    isPotentiallyValid: Yup.boolean().default(true),
    isValid: Yup.boolean().default(false)
});
